<template>
  <div class="page page-Space" :class="{ loaded: isLoaded }">
    <div class="slider">
      <div v-if="!isMobile">
      <template v-for="(image, index) in backgroundImages">
        <div
          class="picture m25"
          :style="bgImgStyle(image, index, backgroundImages)"
          :class="checkSlideClass(index)"
          :key="index"
        ></div>
      </template>
      </div>

      <div
        class="pictures m25"
        v-if="isMobile"
        :class="{
        mobilePictures: isMobile,
        mobilePicturesFull: true
      }"
      >
        <template v-for="(image, index) in backgroundImages">
          <transition
            :enter-active-class="$store.state.enterClassName"
            :leave-active-class="$store.state.leaveClassName"
            :key="index"
          >
            <div class="picture" :style="bgImgStyle(image)" v-if="shownImage == index + 1"></div>
          </transition>
        </template>
      </div>

      <div class="space-video m100" v-if="!isMobile && _('video')">
        <a :href="video" data-fancybox class="btn btn-midi">смотреть видео</a>
      </div>

      <div class="space-text m50" v-if="!isMobile">
        <div class="space-text__title" v-html="_('descriptionTitle')"></div>

        <slide-up-down :active="spaceTextShown" :class="{active: spaceTextShown}">
          <VuePerfectScrollbar class="ps-green" :key="`ps_key_${psKey}`" :settings="psSettings">
            <div v-html="_('description')"></div>
          </VuePerfectScrollbar>
        </slide-up-down>

        <div class="space-text__toggle">
          <span class="a link" v-if="!spaceTextShown" @click="toggleSpaceText()">{{ _('expand') }}</span>
          <span class="a link" v-if="spaceTextShown" @click="toggleSpaceText()">{{ _('collapse') }}</span>
        </div>
      </div>

      <div
        class="content m50"
        v-if="isMobile"
        :class="{
        filter: true,
        'filter-small': true,
        open: mobileFilterOpen,
        hidden: mobilePicturesFull,
      }"
      >
        <div v-hammer:pan="onPan" class="filter__drag" v-if="isMobile">
          <span></span>
        </div>

        <VuePerfectScrollbar class="ps-green scroll-content" :settings="psSettings">
          <div class="space-video" v-if="_('video')">
            <a :href="_('video')" data-fancybox class="btn btn-long">{{ _('see') }}</a>
          </div>

          <div class="space-text__title" v-html="_('descriptionTitle')"></div>
          <div class="space-text__text" v-html="_('description')"></div>
        </VuePerfectScrollbar>
      </div>

      <div class="navigation m100" v-if="backgroundImages.length > 1">
        <div class="pages">{{ shownImage }}/{{ backgroundImages.length }}</div>
        <div class="prev link" :class="{disable: shownImage == 1}" @click="moveImage('prev')"></div>
        <div
          class="next link"
          :class="{disable: shownImage == backgroundImages.length}"
          @click="moveImage('next')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { loader } from '../mixins/loader';
import { isMobile } from '../mixins/isMobile';
import { functions } from '../mixins/functions';

export default {
  name: 'SpaceOffice',
  mixins: [loader, isMobile, functions],

  data() {
    return {
      pageData: {
        page: 'Space',
        subPage: 'Office',
        isMobileFooterHidden: true
      },
      backgroundImages: [],
      shownImage: 1,
      psSettings: {
        suppressScrollX: true
      },
      psKey: 0,
      spaceTextShown: false,
      mobileFilterOpen: false,
      mobilePicturesFull: false
    };
  },

  deactivated() {
    this.isLoaded = false;
  },

  activated() {
    var _t = this;
    this.psKey++;

    if (
      _t.$store.state.pagesLoaded.App &&
      _t.$store.state.pagesLoaded.SpaceOffice
    ) {
      _t.onActivated();
    } else {
      _t.$store.commit('loaderON');

      _t.$store.subscribe((mutation, state) => {
        if (
          mutation.type === 'pageLoaded' &&
          mutation.payload.page === 'SpaceOffice'
        ) {
          _t.onActivated();
        }
      });
    }
  },

  created() {
    this.$store.dispatch('loadData', {
      page: 'SpaceOffice'
    });
  },

  methods: {
    onActivated() {
      var _t = this;
      _t.backgroundImages = _t._('backgroundImages');

      if (_t.imagesLoaded) {
        _t.pageLoaded();
      } else {
        let images = [];

        for (var i in _t.backgroundImages) {
          for (var j in _t.backgroundImages[i]) {
            images.push(_t.backgroundImages[i][j]);
          }
        }

        _t.loadImages(images);

        _t.$store.subscribe((mutation, state) => {
          if (
            mutation.type === 'toggleHamburgerMobile' &&
            !state.isHamburgerMobileActive
          ) {
            _t.mobilePicturesFull = false;
          }
        });
      }
    },
    moveImage(delta) {
      let _t = this;

      if (delta === 'prev') {
        if (_t.shownImage !== 1) {
          --_t.shownImage;
        }
      } else {
        if (_t.shownImage !== _t.backgroundImages.length) {
          ++_t.shownImage;
        }
      }
    },
    toggleSpaceText() {
      var _t = this;

      _t.spaceTextShown = !_t.spaceTextShown;
    },
    checkSlideClass(index) {
      let _t = this;
      let slideClass = {};

      slideClass.active = index + 1 === _t.shownImage;

      if (index + 1 < _t.shownImage) {
        slideClass.before = true;
      }
      if (index + 1 > _t.shownImage) {
        slideClass.after = true;
      }
      if (index + 1 === _t.backgroundImages.length) {
        slideClass.last = true;
      }

      return slideClass;
    },
    onPan: function(event) {
      var _t = this;

      if (_t.mobileFilterInAction) {
        return;
      }

      _t.mobileFilterInAction = true;

      if (event.additionalEvent === 'panup' && !_t.mobileFilterOpen) {
        _t.mobileFilterOpen = true;
        _t.$store.commit('toggleFilter');
      } else if (event.additionalEvent === 'pandown') {
        if (_t.mobileFilterOpen) {
          _t.mobileFilterOpen = false;
          _t.$store.commit('toggleFilter');
        } else {
          _t.mobilePicturesFullToggle();
        }
      }

      setTimeout(function() {
        _t.mobileFilterInAction = false;
      }, 1000);
    },
    mobilePicturesFullToggle() {
      let _t = this;

      _t.$store.commit('toggleHamburgerMobile');

      _t.mobilePicturesFull = !_t.mobilePicturesFull;
    }
  }
};
</script>
